// extracted by mini-css-extract-plugin
export default {"SiteOrange":"#EF7C00","SiteLightGrey":"#B1B1B1","Main":"Spinner_Main__EmpmA","MainPadding":"Spinner_MainPadding__KPWqx","Orange":"Spinner_Orange__GPzap","Gray":"Spinner_Gray__mevmW"};